<template>
  <div class="posite-box">
    <div class="posite inner">
      <template v-if="this.$route.path == '/jzabout'">
         <ul class="posite-menu" >
          <li v-for="(item, index) in LevalMenu.child" :key="index">
            <a @click="goAnchor(`#${item.biaoshi.slice(1)}`)" href="javascript:;">{{item.name}}</a>
          </li>
        </ul>
        <div class="posite-map" >
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
          <router-link v-if="LevalMenu.biaoshi" :to="LevalMenu.biaoshi">{{LevalMenu.name}}</router-link>
        </div>
      </template>
      <template v-else>
        <ul class="posite-menu">
          <li v-for="(item, index) in LevalMenu.child" :key="index">
            <router-link :to="item.biaoshi">{{item.name}}</router-link>
          </li>
        </ul>
        <div class="posite-map" >
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
          <router-link v-if="LevalMenu.biaoshi" :to="`${LevalMenu.biaoshi}`">{{LevalMenu.name}}</router-link>
          <b>></b>
          <span>{{indexShow.name}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    LevalMenu: Object,
    indexShow: Object
  },
  methods: {
    goAnchor (selector) {
      console.log(1)
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    }
  },
  watch: {
    $route (to, from) {
      const id = this.$route.query.id
      this.goAnchor(`#${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/common/index.less");
</style>
